var _ = require('underscore');
var $ = require('jquery');
var Backgrid = require('backgrid');
var Behaviors = require('Behaviors');
var Marionette = require('marionette');
var Authorization = require('Authorization');
var DialogConfirmation = require('DialogConfirmation');
var DialogWarning = require('DialogWarning');
var DragDrop = require('DragDrop');
var Entities = require('Entities');
var FileSaver = require('file-saverjs');
var Grid = require('Grid');
var JSZip = require('jszip');
var JSZipUtils = require('jszip-utils');
var Logger = require('Logger');
var RecordDocumentationSync = require('RecordDocumentationSync');
var Solr = require('Solr');
var Configuration = EY.Consultation.Lookups.Configuration;
var Labels = EY.Consultation.Labels;
var Lookups = EY.Consultation.Lookups;
var StatusType = EY.Consultation.Lookups.StatusType;
var User = EY.Consultation.CurrentUser;
var Validation = require('validation');

var headerCell = Backgrid.HeaderCell.extend({
    render: function () {
        Backgrid.HeaderCell.prototype.render.apply(this, arguments);
        this.$el.addClass('visible-lg visible-md visible-print');
        return this;
    }
});

var stringCell = Backgrid.StringCell.extend({
    render: function () {
        Backgrid.StringCell.prototype.render.apply(this, arguments);
        this.$el.addClass('visible-lg visible-md visible-print');
        return this;
    }
});

var approverGroup = function (record) {
    var configuration = record.get('configuration');
    var approvers = new Entities.Approvers(record.get('approvers'));
    var approver = approvers.find({ approverGroupId: record.get('approverGroupId'), upn: record.get('assignedTo') });
    return _.findWhere(configuration.groups, { id: approver ? approver.get('approverGroupId') : '' });
};

var Layout = Marionette.View.extend({
    initialize: function () {
        Validation.bind(this);
    },
    behaviors: [{ behaviorClass: Authorization.RBAC, viewName: 'recordDocumentation' }, Behaviors.PrintCheckbox, Behaviors.MobileView],
    events: {
        'blur @ui.communication': 'update',
        'change @ui.description': 'descriptionChanged',
        //'change @ui.file': 'file',
        //'click @ui.file': 'reset',
        //'click @ui.add': 'add',
        'click @ui.discussed': 'discussed',
        'click @ui.downloadAll': 'downloadAll'
    },
    regions: {
        grid: '#grid',
        add: '#add'
    },
    template: '#recordDocumentationLayout',
    ui: {
        add: '#add',
        communication: '#communication',
        description: '#description',
        descriptionLabel: "#descriptionLabel",
        descriptionContainer: '#descriptionContainer',
        discussed: '#discussed',
        discussedContainer: '#discussedContainer',
        //file: '#file',
        form: '#form',
        approverCommunication: '#approverCommunication',
        downloadAll: '#downloadAll'
    },
    onRender: function () {
        var configuration = this.model.get('configuration');

        this.ui.descriptionContainer.removeClass(configuration.DisplayDescription ? 'hidden' : '');
        this.ui.descriptionLabel.html(configuration.DisplayDescription ? Labels[this.model.get('recordTypeId') + '_Description'] : '');
        //this.ui.file.attr('accept', Configuration.FileExtensionWhitelist + ',.doc,.ppt,.xls');
        if (!configuration.DisplayApproverCommunication || this.model.get('statusTypeId') === StatusType.Complete) {
            this.ui.approverCommunication.addClass('hidden');
        }
        if (configuration.DisplayCreatorAcknowledgement) {
            this.ui.discussedContainer.removeClass('hidden');
            if (this.model.get('discussed')) {
                this.ui.discussed.prop('checked', true).prop('disabled', 'disabled');
            }
        }
    },
    //add: function () {
    //    this.ui.file.click();
    //},
    discussed: function () {
        this.model.set('discussed', true);
        this.ui.discussed.prop('disabled', 'disabled');
    },
    onAttach: function () {
        var scope = this;
        DragDrop.show({
            region: this.getRegion('add'),
            change: function (files) {
                if (files) {
                    _.each(files, function (file) {
                        scope.saveFile(file);
                    });
                }
            }
        });
    },
    saveFile: function (file) {
        var consultation = require('Consultation');
        var files = $('#file');
        var record = this.options.record;
        var countryId = record.get('countryId');
        var redbox = Lookups.RedBoxCountryApi[countryId]; //Redbox country patch.
        var attachment = !redbox ? new Entities.Attachment() : _.extend(new Entities.Attachment(), { urlRoot: redbox + 'Attachment' });
        var collection = this.collection;
        var form = new FormData();
        form.append('file', file);
        var zone = Configuration.RedboxZone !== 'false' && redbox ? record.get('countryId').replace(/^\/|\/$/ig, '').replace(/\//ig, '-') : Configuration.Database;
        var fileName = file.name.split(/\.(?=[^\.]+$)/)[0];
        var fileExt = file.name.split('.').pop();
        var fileNameWithExt = fileName.replace(/[-'`~!@#$%^&*()_|+=?;:'",.<>\{\}\[\]\\\/]/gi, '') + "." + fileExt;
        var fileExists = _.find(collection.models, 
            function (i) { 
                return i.get('filename').toLowerCase() == fileNameWithExt.toLowerCase();
            }); 
            
        if (file) {
            var allowed = _.find(Configuration.FileExtensionWhitelist.split(','), function (ext) {
                return fileNameWithExt.toLowerCase().match(ext.toLowerCase() + '$') == ext.toLowerCase();
            });
            var oversized = file.size > Configuration.DocumentSize;
            var sized = Configuration.MaxDocumentSize >= collection.reduce(function (memo, model) {
                return memo + model.get('filelength');
            }, file.size);

            if (allowed && !oversized && sized && !fileExists) {
                $('html,body').addClass('wait-cursor');
                form.append('zone', zone);
                attachment.save({ filename: fileNameWithExt, zone: zone, date: _.last(new Date().toGMTString().split(',')), size: Math.round(file.size / 1024) + 'KB' }, {
                    contentType: false,
                    processData: false,
                    data: form
                }).done(function () {
                    $('html,body').removeClass('wait-cursor');
                    attachment.set('date', _.last(new Date(attachment.get('uploadDate').$date).toGMTString().split(',')));
                    attachment.set('filename', fileNameWithExt);
                    collection.add(attachment);
                    Solr.index({ id: attachment.id, formData: form });
                    if (form.delete) {
                        form.delete('file');
                    }
                    record.isValid('attachments');
                    record.isValid('description');
                    EY.Consultation.Lookups.IsHandHeldDevice &&
                    Logger.logToServer(JSON.stringify({
                        device:EY.Consultation.Lookups.IsHandHeldDevice[0],
                        rank:EY.Consultation.CurrentUser.rank,
                        location:EY.Consultation.CurrentUser.location.country,
                        action:'File upload succeded'}),'handHeldDevice');
                }).fail(function () {
                    $('html,body').removeClass('wait-cursor');
                    EY.Consultation.Lookups.IsHandHeldDevice &&
                    Logger.logToServer(JSON.stringify({
                        device:EY.Consultation.Lookups.IsHandHeldDevice[0],
                        rank:EY.Consultation.CurrentUser.rank,
                        location:EY.Consultation.CurrentUser.location.country,
                        action:'File upload failed'}),'handHeldDevice');
                });
            } else {
                var text = (!allowed ? Labels.FileTypeError : (oversized ? Labels.MaxSizePerFile : Labels.MaxTotalAttachmentSize));
                text = fileExists ? Labels.SameFileNameAttachment : text;
                consultation.showToast({
                    result: "danger",
                    text: text
                });
            }
        }
    },
    downloadAll: function () {
        var options = this.options;
        var urls = [];
        var attachments = options.attachments.models;
        var record = options.record;
        _.each(attachments, function (attachment) {
            var filePath = window.encodeURI(attachment.urlRoot + '/' + attachment.id + '?zone=' + attachment.get('zone') + '&name=' + attachment.get('filename').replace('#', ' ') + '&token=' + Lookups.Azure.Token);
            urls.push({ filePath: filePath, fileName: attachment.get('filename') });
        });
        var zipFileName = Labels.Record + "_" + (record.get('shortId') ? record.get('shortId') + "_" + Labels.Attachments : Labels.Attachments);
        var zip = new JSZip();
        var count = 0;
        var duplicateCount = 1;
        var name = zipFileName + ".zip";
        var copyFileName = "";
        var filterFileNames = _.pluck(urls, 'fileName');
        _.each(urls, function (url) {
            JSZipUtils.getBinaryContent(url.filePath, function (err, data) {
                if (err) {
                    throw err;
                }
                var filename = url.fileName;
                if (copyFileName == url.fileName) {
                    var fileNameNoExt = copyFileName.split(/\.(?=[^\.]+$)/)[0];
                    var fileExt = copyFileName.split('.').pop();
                    filename = fileNameNoExt + " (" + duplicateCount + ")" + "." + fileExt;
                    duplicateCount++;
                }
                else {
                    duplicateCount = 1;
                }
                zip.file(filename, data, { binary: true });
                count++;
                var uniqs = filterFileNames.reduce((acc, val) => {
                    acc[val] = acc[val] === undefined ? 1 : acc[val] += 1;
                    return acc;
                }, {});
                if (uniqs[url.fileName] > 1)
                    copyFileName = url.fileName;
                if (count == attachments.length) {
                    zip.generateAsync({ type: 'blob' }).then(function (content) {
                        FileSaver(content, name);
                    });
                }
            });
        });
        //}
    },
    reset: function () {
        //this.ui.file[0].value = null;
    },
    update: function () {
        this.model.set('communication', this.ui.communication.val());
    },
    descriptionChanged: function () {
        var context = this;
        var group = approverGroup(this.model);

        if (!group || group.allowApprovalPostDocumentationEdits) {
            context.model.set('description', context.ui.description.val());
        } else {
            DialogConfirmation.show({
                message: Labels.MSG019
            }).done(function () {
                context.model.set('description', context.ui.description.val());
            }).fail(function () {
                context.ui.description.val(context.model.get('description'));
            });
        }
        if (context.model.get('description').length > 0) {
            context.model.isValid('attachments');
        }
    }
});

var Action = Marionette.View.extend({
    events: {
        'click @ui.delete': 'delete'
    },
    tagName: 'td',
    template: '#recordDocumentationGridAction',
    ui: {
        delete: '#delete',
        download: '#download'
    },
    onRender: function () {
        //Code change for downloading files with # in the file name. (Relpace # with ' ')
        this.ui.download.prop('href', window.encodeURI(this.model.urlRoot + '/' + this.model.id + '?zone=' + this.model.get('zone') + '&name=' + this.model.get('filename').replace('#', ' ') + '&token=' + Lookups.Azure.Token));
    },                  
    'delete': function () {
        context = this;
        var record = context.options.column.collection.models[0].get('record');
        var recordStatusType = record.get('statusTypeId');
        var deleteMsg = (recordStatusType === "StatusType_Draft" ||
            recordStatusType === "StatusType_Preparation" ||
            recordStatusType === "StatusType_ReturnForRevision") ? Labels.MSG030 :  Labels.MSG034;
        DialogConfirmation.show({
            message: deleteMsg
        }).done(function () {
            context.model.collection.remove(context.model);
        });
    }
});

var DateView = Marionette.View.extend({
    className: 'sting-cell sortable renderable visible-lg visible-md visible-print',
    tagName: 'td',
    template: _.noop,
    onRender: function () {
        this.$el.html(new Date(this.model.get(this.options.column.get('name'))).format());
    }
});

var Error = Marionette.View.extend({
    tagName: 'td',
    template: '#recordDocumentationGridError'
});
var Edit = Marionette.View.extend({
    events: {
        'click @ui.edit': 'edit'
    },
    tagName: 'td',
    template: '#recordDocumentationGridEditAction',
    ui: {
        edit: '#edit'
    },
    onRender: function () {
        var uriProtocol = this.uriProtocol();
        var record = this.options.column.get('record');

       if (uriProtocol && record.get('statusTypeId') !== StatusType.Complete && record.get('statusTypeId') !== StatusType.UsersNotified) {
            var path = "file=" + this.model.id + "&entity=record&id=" + record.id + "&key=lockedOn&user=lockedBy&upn=" + User.upn + '&zone=' + this.model.get('zone');
            this.ui.edit.prop('href', window.encodeURI(uriProtocol + ':ofe|u|' + this.model.urlRoot.replace(/Attachment/g, 'AutoUpload') + '/' + path + '/' + this.model.get('filename')));
        } else {
            //Code change for downloading files with # in the file name. (Relpace # with ' ')
            this.ui.edit.prop('href', window.encodeURI(this.model.urlRoot + '/' + this.model.id + '?zone=' + this.model.get('zone') + '&name=' + this.model.get('filename').replace('#', ' ') + '&token=' + Lookups.Azure.Token));
        }


        Behaviors.tooltip(this.$el.find(".tooltip-css"));
    },
    edit: function (e) {
        var context = this;
        var record = context.options.column.get('record');
        var group = approverGroup(record);
        if (!EY.Consultation.Lookups.IsHandHeldDevice) {
            if (!group || group.allowApprovalPostDocumentationEdits) {
                e.preventDefault();
                context.model.set('edited', true);
                window.location = context.ui.edit.prop('href');
            } else if (this.uriProtocol() && record.get('statusTypeId') !== StatusType.Complete) {
                e.preventDefault();
                DialogConfirmation.show({
                    message: Labels.MSG028
                }).done(function () {
                    context.model.set('edited', true);
                    window.location = context.ui.edit.prop('href');
                });
            }
        }
        EY.Consultation.Lookups.IsHandHeldDevice &&
        Logger.logToServer(JSON.stringify({
            device:EY.Consultation.Lookups.IsHandHeldDevice[0],
            rank:EY.Consultation.CurrentUser.rank,
            location:EY.Consultation.CurrentUser.location.country,
            action:'File opened for inline editing.'}),'handHeldDevice');
    },
    uriProtocol: function () {
        var name = this.model.get('filename');
        var extension = name.slice((name.lastIndexOf(".") - 1 >>> 0) + 2);

        return extension.match(/docm|docx/g) ? 'ms-word' : extension.match(/xlsb|xlsm|xlsx/g) ? 'ms-excel' : null;
    }
});

var columns = function (options) {
    var record = options.record;

    return [{ name: '', label: Labels.FileName, editable: false, cell: Edit, record: record, sortable: false },
    { name: 'size', label: Labels.FileSize, editable: false, cell: stringCell, sortable: false,headerCell:headerCell},
    { name: 'date', label: Labels.UploadDate, editable: false, cell: DateView, sortable: false,headerCell:headerCell },
    { name: '', label: '', editable: false, cell: Action, sortable: false },
        { name: '', label: '', editable: false, cell: Error, sortable: false }];
};

var reconcile = function (options) {
    var attachments = options.attachments;
    var record = options.record;
    var added = [];
    var removed = [];

    RecordDocumentationSync.start(options);
    attachments.on('add', function (attachment) {
        added.push(attachment);
    });
    attachments.on('change:edited', function (attachment) {
        var found = _.findWhere(options.history.attachments, { id: attachment.id });

        if (options.record.id && found) {
            found.edited = true;
            new Entities.Record(options.history).save({ validate: false });
        } //save the attachments collection with edited flag
    });
    attachments.on('remove', function (attachment) {
        removed.push(attachment);
    });
    record.on('save', function () {
        _.each(removed, function (attachment) {
            attachment.destroy({ data: { zone: attachment.get('zone') }, processData: true });
            Solr.delete({ id: attachment.id });
            EY.Consultation.Lookups.IsHandHeldDevice &&
            Logger.logToServer(JSON.stringify({
                device:EY.Consultation.Lookups.IsHandHeldDevice[0],
                rank:EY.Consultation.CurrentUser.rank,
                location:EY.Consultation.CurrentUser.location.country,
                action:'File deleted'}),'handHeldDevice');
        });
    });
    record.on('cancel', function () {
        _.each(added, function (attachment) {
            attachment.destroy({ data: { zone: attachment.get('zone') }, processData: true });
            Solr.delete({ id: attachment.id });
            EY.Consultation.Lookups.IsHandHeldDevice &&
            Logger.logToServer(JSON.stringify({
                device:EY.Consultation.Lookups.IsHandHeldDevice[0],
                rank:EY.Consultation.CurrentUser.rank,
                location:EY.Consultation.CurrentUser.location.country,
                action:'File upload cancelled'}),'handHeldDevice');
        });
    });
};

var validation = function (options) {
    var configuration = options.record.get('configuration');

    return configuration.DisplayDescription ?
        {
            description: function (value) { return !(value || options.attachments.length) ? Labels.AADescriptionError : ''; },
            attachments: function () { return !(this.get('description') || options.attachments.length) ? Labels.AAAttachmentError : ''; }
        } :
        {
            attachments: function () { return options.attachments.length ? '' : Labels.PleaseAddFile; },
            description: function () { return ''; }
        };
};

module.exports.start = function (options) {
    var attachments = options.attachments;
    var record = options.record;
    var region = options.region;
    var layout = new Layout(_.extend({}, options, {
        collection: attachments,
        model: record
    }));

    record.validation = _.extend(record.validation || {}, validation(options));
    region.show(layout);
    Grid.show({
        collection: attachments,
        columns: columns(options),
        region: layout.getRegion('grid')
    });
    reconcile(options);
};


// WEBPACK FOOTER //
// ./js/Modules/Record/UI/RecordDocumentation.js